export const newClientVersionDialogStrings = {
    title: 'Neue Version des MiBi-Portals verfügbar',
    text: `Auf dem Server liegt eine neuere Version des MiBi-Portals als die in diesem
    Browser-Fenster geladene. Um Datenverlust und Fehler zu vermeiden, muss die Seite
    neu geladen werden.`,
    dataLossWarning: `Bitte beachten Sie: Alle noch nicht abgesendeten Eingaben in diesem
    Fenster gehen dabei verloren. Gegebenenfalls müssen Sie sich anschließend erneut anmelden.`,
    reloadButtonLabel: 'Seite neu laden'
};
